// Generated by Melange

import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TisCardMobile(Props) {
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("img", {
          className: "max-w-none w-pct-130 sm:w-full",
          alt: "tis ui",
          src: StaticAsset.src("/static/images/tis-ui.svg")
        }),
        className: "overflow-hidden"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4 shrink-0",
                src: StaticAsset.src("/static/icons/cashier.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h6", {
                    children: "Контрольный компонент",
                    className: "h6 text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Контрольно-кассовая машина «Аппаратно-программный комплекс «Бухта 1.0» с функцией фиксации и передачи данных, включенная в государственный реестр контрольно-кассовых машин под номером 223.",
                    className: "paragraph text-gray-landing"
                  })
                ]
              })
            ],
            className: "flex"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4 shrink-0",
                src: StaticAsset.src("/static/icons/papers.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h6", {
                    children: "Сдача налоговой отчетности",
                    className: "h6 text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Платежный компонент ТИС - система для приема безналичных платежей.",
                    className: "paragraph text-gray-landing"
                  })
                ]
              })
            ],
            className: "flex mt-4"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mr-4 shrink-0",
                src: StaticAsset.src("/static/icons/integration.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h6", {
                    children: "Интеграция с банком",
                    className: "h6 text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Учетный компонент ТИС - программа для автоматизации управления торговли, оказания услуг, выполнения работ и учета товаров.",
                    className: "paragraph text-gray-landing"
                  })
                ]
              })
            ],
            className: "flex mt-4"
          })
        ],
        className: "px-6 sm:px-24 -mt-12"
      })
    ]
  });
}

const make = TisCardMobile;

export {
  make,
}
/* react Not a pure module */
